import { __assign, __rest } from "tslib";
import React from 'react';
import { Manager as PopperManager } from 'react-popper';
import DropdownStateManager from '../DropdownStateManager';
var PopperDropdownManager = function (_a) {
    var children = _a.children, dropdownProps = __rest(_a, ["children"]);
    return (React.createElement(DropdownStateManager, __assign({}, dropdownProps),
        React.createElement(PopperManager, null, children)));
};
PopperDropdownManager.displayName = 'PopperDropdownManager';
export default PopperDropdownManager;
//# sourceMappingURL=PopperDropdownManager.js.map